import { render, staticRenderFns } from "./industrialparkDetail.vue?vue&type=template&id=7c40e2a3&"
import script from "./industrialparkDetail.vue?vue&type=script&lang=js&"
export * from "./industrialparkDetail.vue?vue&type=script&lang=js&"
import style0 from "./industrialparkDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports